export default {
    ENTREPRENEUR: "ENTREPRENEUR",
    ARTISAN: "ARTISAN",
    ADMIN_FORCE_ARTISAN_APP_AUTH: "ADMIN_FORCE_ARTISAN_APP_AUTH"
}
